import { render, staticRenderFns } from "./channelList.vue?vue&type=template&id=9bb76534&scoped=true&"
import script from "./channelList.vue?vue&type=script&lang=js&"
export * from "./channelList.vue?vue&type=script&lang=js&"
import style0 from "./channelList.vue?vue&type=style&index=0&id=9bb76534&prod&lang=less&scoped=true&"
import style1 from "./channelList.vue?vue&type=style&index=1&id=9bb76534&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb76534",
  null
  
)

export default component.exports